<template>
    <div class="outer">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="供应商列表" name="1">
                <GoodsSupplier v-if="activeName === '1'" />
            </el-tab-pane>
            <el-tab-pane label="货物分类列表" name="2">
                <GoodsCategory v-if="activeName === '2'" />
            </el-tab-pane>
            <el-tab-pane label="货物列表" name="3">
                <GoodsManage v-if="activeName === '3'" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import GoodsCategory from './components/GoodsCategory.vue';
import GoodsManage from './components/GoodsManage.vue';
import GoodsSupplier from './components/GoodsSupplier.vue';
export default {
    data() {
        return {
            activeName: '1',
        }
    },
    components: {
        GoodsCategory,
        GoodsManage,
        GoodsSupplier
    },
    created() {
    },
    computed: {

    },
    methods: {

    },
}
</script>
<style lang="scss" scoped></style>
